import React from "react";

function TestimonialSection() {
  return (
    <div>
      <section className="testimonial-section bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-4 g-lg-5">
            <div className="col-12 col-lg-5">
              <div className="section-heading">
                <div className="sub-title">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Testimonial
                </div>
                <h2 className="mb-4">What Say Customers About Company</h2>
                <p className="mb-0">
                  Aliquam eu nunc imperdiet, volutpat mi vel, lobortis ligula.
                  pharetra dignissim lacus, faucibus volutpat lorem suscipit
                  nec. Nunc fringilla.
                </p>
              </div>
            </div>

            <div className="col-12 col-lg-7">
              <div className="swiper testimonial-swiper-three">
                <div className="swiper-wrapper">
                  {/* Testimonial Slide */}
                  <div className="swiper-slide testimonial-slide-item">
                    <div className="testimonial-stars">
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                    </div>
                    <p>
                      “He quickly delivered excellent design a per required
                      specifications. New landing page will have refreshing
                      simple look, while keeping page load light on images and
                      at the same keeping professional look. Finally, it also
                      seems very reasonable to implement responsive design, so
                      I'm very happy with that.”
                    </p>
                    <div className="testimonial-author-info d-flex align-items-center justify-content-between gap-4">
                      <div className="testimonial-author d-flex align-items-center gap-3">
                        <img src="assets/img/bg-img/55.jpg" alt="" />
                        <div>
                          <div>Peggy Thompson</div>
                          <p className="mb-0">Product Manager</p>
                        </div>
                      </div>

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="62"
                        height="62"
                        viewBox="0 0 62 62"
                        fill="none"
                      >
                        <path
                          d="M14.5312 9.41406C6.51702 9.41406 0 15.9329 0 23.9453C0 31.2606 5.43154 37.3306 12.4771 38.3311C11.9131 42.4287 10.3486 46.3275 7.90415 49.7085C7.42874 50.3683 7.44654 51.2624 7.9538 51.9009C8.4515 52.5292 9.31635 52.7674 10.0754 52.4473C21.6088 47.6332 29.0625 36.4438 29.0625 23.9453C29.0625 15.9329 22.5455 9.41406 14.5312 9.41406ZM47.4688 9.41406C39.4545 9.41406 32.9375 15.9329 32.9375 23.9453C32.9375 31.2606 38.369 37.3306 45.4146 38.3311C44.8506 42.4287 43.2861 46.3275 40.8417 49.7085C40.3662 50.3683 40.384 51.2624 40.8913 51.9009C41.389 52.5292 42.2538 52.7674 43.0129 52.4473C54.5463 47.6332 62 36.4438 62 23.9453C62 15.9329 55.483 9.41406 47.4688 9.41406Z"
                          fill="#D3A574"
                        />
                      </svg>
                    </div>
                  </div>

                  {/* Testimonial Slide */}
                  <div className="swiper-slide testimonial-slide-item">
                    <div className="testimonial-stars">
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                    </div>
                    <p>
                      “He quickly delivered excellent design a per required
                      specifications. New landing page will have refreshing
                      simple look, while keeping page load light on images and
                      at the same keeping professional look. Finally, it also
                      seems very reasonable to implement responsive design, so
                      I'm very happy with that.”
                    </p>
                    <div className="testimonial-author-info d-flex align-items-center justify-content-between gap-4">
                      <div className="testimonial-author d-flex align-items-center gap-3">
                        <img src="assets/img/bg-img/55.jpg" alt="" />
                        <div>
                          <div>Thelma Torp Sr.</div>
                          <p className="mb-0">Civil lawyer</p>
                        </div>
                      </div>

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="62"
                        height="62"
                        viewBox="0 0 62 62"
                        fill="none"
                      >
                        <path
                          d="M14.5312 9.41406C6.51702 9.41406 0 15.9329 0 23.9453C0 31.2606 5.43154 37.3306 12.4771 38.3311C11.9131 42.4287 10.3486 46.3275 7.90415 49.7085C7.42874 50.3683 7.44654 51.2624 7.9538 51.9009C8.4515 52.5292 9.31635 52.7674 10.0754 52.4473C21.6088 47.6332 29.0625 36.4438 29.0625 23.9453C29.0625 15.9329 22.5455 9.41406 14.5312 9.41406ZM47.4688 9.41406C39.4545 9.41406 32.9375 15.9329 32.9375 23.9453C32.9375 31.2606 38.369 37.3306 45.4146 38.3311C44.8506 42.4287 43.2861 46.3275 40.8417 49.7085C40.3662 50.3683 40.384 51.2624 40.8913 51.9009C41.389 52.5292 42.2538 52.7674 43.0129 52.4473C54.5463 47.6332 62 36.4438 62 23.9453C62 15.9329 55.483 9.41406 47.4688 9.41406Z"
                          fill="#D3A574"
                        />
                      </svg>
                    </div>
                  </div>

                  {/* Testimonial Slide */}
                  <div className="swiper-slide testimonial-slide-item">
                    <div className="testimonial-stars">
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                    </div>
                    <p>
                      “He quickly delivered excellent design a per required
                      specifications. New landing page will have refreshing
                      simple look, while keeping page load light on images and
                      at the same keeping professional look. Finally, it also
                      seems very reasonable to implement responsive design, so
                      I'm very happy with that.”
                    </p>
                    <div className="testimonial-author-info d-flex align-items-center justify-content-between gap-4">
                      <div className="testimonial-author d-flex align-items-center gap-3">
                        <img src="assets/img/bg-img/57.jpg" alt="" />
                        <div>
                          <div>Luis Bechtelar</div>
                          <p className="mb-0">Orchestrator</p>
                        </div>
                      </div>

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="62"
                        height="62"
                        viewBox="0 0 62 62"
                        fill="none"
                      >
                        <path
                          d="M14.5312 9.41406C6.51702 9.41406 0 15.9329 0 23.9453C0 31.2606 5.43154 37.3306 12.4771 38.3311C11.9131 42.4287 10.3486 46.3275 7.90415 49.7085C7.42874 50.3683 7.44654 51.2624 7.9538 51.9009C8.4515 52.5292 9.31635 52.7674 10.0754 52.4473C21.6088 47.6332 29.0625 36.4438 29.0625 23.9453C29.0625 15.9329 22.5455 9.41406 14.5312 9.41406ZM47.4688 9.41406C39.4545 9.41406 32.9375 15.9329 32.9375 23.9453C32.9375 31.2606 38.369 37.3306 45.4146 38.3311C44.8506 42.4287 43.2861 46.3275 40.8417 49.7085C40.3662 50.3683 40.384 51.2624 40.8913 51.9009C41.389 52.5292 42.2538 52.7674 43.0129 52.4473C54.5463 47.6332 62 36.4438 62 23.9453C62 15.9329 55.483 9.41406 47.4688 9.41406Z"
                          fill="#D3A574"
                        />
                      </svg>
                    </div>
                  </div>

                  {/* Testimonial Slide */}
                  <div className="swiper-slide testimonial-slide-item">
                    <div className="testimonial-stars">
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                      <i className="ti ti-star-filled"></i>
                    </div>
                    <p>
                      “He quickly delivered excellent design a per required
                      specifications. New landing page will have refreshing
                      simple look, while keeping page load light on images and
                      at the same keeping professional look. Finally, it also
                      seems very reasonable to implement responsive design, so
                      I'm very happy with that.”
                    </p>
                    <div className="testimonial-author-info d-flex align-items-center justify-content-between gap-4">
                      <div className="testimonial-author d-flex align-items-center gap-3">
                        <img src="assets/img/bg-img/58.jpg" alt="" />
                        <div>
                          <div>Cornelius Parker</div>
                          <p className="mb-0">Business Law Service</p>
                        </div>
                      </div>

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="62"
                        height="62"
                        viewBox="0 0 62 62"
                        fill="none"
                      >
                        <path
                          d="M14.5312 9.41406C6.51702 9.41406 0 15.9329 0 23.9453C0 31.2606 5.43154 37.3306 12.4771 38.3311C11.9131 42.4287 10.3486 46.3275 7.90415 49.7085C7.42874 50.3683 7.44654 51.2624 7.9538 51.9009C8.4515 52.5292 9.31635 52.7674 10.0754 52.4473C21.6088 47.6332 29.0625 36.4438 29.0625 23.9453C29.0625 15.9329 22.5455 9.41406 14.5312 9.41406ZM47.4688 9.41406C39.4545 9.41406 32.9375 15.9329 32.9375 23.9453C32.9375 31.2606 38.369 37.3306 45.4146 38.3311C44.8506 42.4287 43.2861 46.3275 40.8417 49.7085C40.3662 50.3683 40.384 51.2624 40.8913 51.9009C41.389 52.5292 42.2538 52.7674 43.0129 52.4473C54.5463 47.6332 62 36.4438 62 23.9453C62 15.9329 55.483 9.41406 47.4688 9.41406Z"
                          fill="#D3A574"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Testimonial Pagination */}
          <div className="testimonial-three-pagination"></div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default TestimonialSection;
